import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import { createMediaQuery } from "@universityofmaryland/web-utilities-library/styles";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "../../animations/brand/chevron-scroll.js";
import "../../animations/brand/card-stack.js";
import { createImageBackground } from "../../assets/image/background.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../block/stacked.js";
import "../overlay/modal.js";
import { createTextLockupContact } from "../../text-lockup/contact.js";
import "../../text-lockup/date.js";
import { createTextLockupPerson } from "../../text-lockup/person.js";
import "../../text-lockup/small.js";
const smallBreakpoint = token.media.breakpointValues.small.max;
const mediumBreakpointStart = token.media.breakpointValues.medium.min;
const mediumBreakpoint = token.media.breakpointValues.large.min;
const image = ({
  customStyles,
  image: image2,
  isThemeDark
}) => {
  const backgroundImage = createImageBackground({
    element: image2,
    isScaled: false,
    imageLoading: "lazy"
  });
  return new ElementBuilder().withClassName("person-column-image").withStyles({
    element: {
      ...createMediaQuery("max-width", smallBreakpoint, {
        marginBottom: `${token.spacing.md}`,
        backgroundColor: `${token.color.gray.lighter}`,
        display: "flex",
        justifyContent: "center",
        ...isThemeDark && {
          ...createMediaQuery("max-width", smallBreakpoint, {
            backgroundColor: `${token.color.gray.darker}`
          })
        }
      }),
      ...createMediaQuery("min-width", mediumBreakpointStart, {
        display: "block",
        width: "96px",
        minWidth: "96px",
        paddingRight: `${token.spacing.md}`,
        alignSelf: "flex-start"
      }),
      ...customStyles,
      "& img, & svg": {
        ...createMediaQuery("max-width", smallBreakpoint, {
          height: "auto !important",
          width: "140px",
          minWidth: "140px"
        })
      }
    }
  }).withChild(backgroundImage).build();
};
const personLockup = ({
  actions,
  slotTwo,
  isThemeDark,
  slotOne,
  name,
  nameComposite,
  slotThreeItalic,
  slotFour
}) => createTextLockupPerson({
  actions,
  name,
  nameComposite,
  slotOne,
  slotTwo,
  slotThreeItalic,
  slotFour,
  isThemeDark
});
const details = (props) => {
  const { customStyles = {} } = props;
  const lockup = personLockup(props);
  return new ElementBuilder().withClassName("person-column-details").withStyles({
    element: {
      flex: "1 0",
      ...customStyles
    }
  }).withChild(lockup).build();
};
const contactLockup = ({
  actions,
  additionalContact,
  address,
  email,
  isThemeDark,
  linkedin,
  phone
}) => createTextLockupContact({
  actions,
  address,
  email,
  isThemeDark,
  linkedin,
  phone
});
const contact = (props) => {
  const { customStyles = {} } = props;
  const lockup = contactLockup(props);
  return new ElementBuilder().withClassName("person-column-contact").withStyles({
    element: {
      marginTop: `${token.spacing.sm}`,
      ...createMediaQuery("min-width", mediumBreakpointStart, {
        paddingLeft: `${token.spacing.md}`
      }),
      ...createMediaQuery("min-width", mediumBreakpoint, {
        width: "30%"
      }),
      ...customStyles
    }
  }).withChild(lockup).build();
};
const information = ({
  actions,
  additionalContact,
  address,
  slotTwo,
  customStyles = {},
  email,
  isThemeDark,
  slotOne,
  linkedin,
  name,
  phone,
  slotThreeItalic,
  slotFour
}) => {
  const person = personLockup({
    slotTwo,
    isThemeDark,
    slotOne,
    name,
    slotThreeItalic,
    slotFour
  });
  const contact2 = contactLockup({
    actions,
    additionalContact,
    address,
    email,
    isThemeDark,
    linkedin,
    phone
  });
  return new ElementBuilder().withClassName("person-column-information").withStyles({
    element: {
      ...customStyles
    }
  }).withChildren(person, contact2).build();
};
export {
  contact,
  details,
  image,
  information
};
//# sourceMappingURL=columns.js.map
